import basicProduct from './html/basic-product'
import textileDpp from './html/textile-dpp'
import batteryDpp from './html/battery-dpp'

export default [
  {
    id: 'basic-product',
    nameKey: 'custom_html_template_basic_name',
    descKey: 'custom_html_template_basic_desc',
    icon: 'mdi-package-variant-closed',
    html: basicProduct
  },
  {
    id: 'textile-dpp',
    nameKey: 'custom_html_template_textile_name',
    descKey: 'custom_html_template_textile_desc',
    icon: 'mdi-tshirt-crew',
    html: textileDpp
  },
  {
    id: 'battery-dpp',
    nameKey: 'custom_html_template_battery_name',
    descKey: 'custom_html_template_battery_desc',
    icon: 'mdi-battery-charging-100',
    html: batteryDpp
  }
]
